import { elements } from '../../dom';
import { isImageFile } from './media/image';

let fullscreenDragDepth = 0;

export function bindDropZone(
  dropZone: HTMLElement,
  acceptedPrefix: string,
  onFile: (file: File, files: FileList) => void,
) {
  dropZone.addEventListener('dragover', (event) => {
    event.preventDefault();
    dropZone.classList.add('dragging');
  });

  dropZone.addEventListener('dragleave', () => {
    dropZone.classList.remove('dragging');
  });

  dropZone.addEventListener('drop', (event) => {
    event.preventDefault();
    dropZone.classList.remove('dragging');
    const dataTransfer = event.dataTransfer;
    if (!dataTransfer) {
      return;
    }
    const file = dataTransfer.files[0];
    if (file && acceptsDroppedFile(file, acceptedPrefix)) {
      onFile(file, dataTransfer.files);
    }
  });
}

export function bindFullscreenDropZone(onFiles: (files: FileList) => void, isDisabled: () => boolean = () => false) {
  window.addEventListener('dragenter', (event) => {
    if (!isFileDrag(event)) {
      return;
    }
    event.preventDefault();
    if (isDisabled()) {
      return;
    }

    fullscreenDragDepth += 1;
    showFullscreenDropZone();
  });

  window.addEventListener('dragover', (event) => {
    if (!isFileDrag(event)) {
      return;
    }
    event.preventDefault();
    if (isDisabled()) {
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'none';
      }
      hideFullscreenDropZone();
      return;
    }

    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
    showFullscreenDropZone();
  });

  window.addEventListener('dragleave', (event) => {
    if (!isFileDrag(event)) {
      return;
    }
    fullscreenDragDepth = Math.max(0, fullscreenDragDepth - 1);
    if (fullscreenDragDepth === 0 || hasLeftWindow(event)) {
      hideFullscreenDropZone();
    }
  });

  window.addEventListener('drop', (event) => {
    if (!isFileDrag(event)) {
      return;
    }
    fullscreenDragDepth = 0;
    hideFullscreenDropZone();
    if (event.defaultPrevented) {
      return;
    }
    event.preventDefault();
    if (isDisabled()) {
      return;
    }

    const files = event.dataTransfer?.files;
    if (files?.length) {
      onFiles(files);
    }
  });
}

function acceptsDroppedFile(file: File, acceptedPrefix: string) {
  return file.type.startsWith(acceptedPrefix) || (acceptedPrefix === 'image/' && isImageFile(file));
}

function isFileDrag(event: DragEvent) {
  return Array.from(event.dataTransfer?.types ?? []).includes('Files');
}

function hasLeftWindow(event: DragEvent) {
  return event.clientX <= 0 || event.clientY <= 0 || event.clientX >= window.innerWidth || event.clientY >= window.innerHeight;
}

function showFullscreenDropZone() {
  elements.fullscreenDropZone.hidden = false;
}

function hideFullscreenDropZone() {
  elements.fullscreenDropZone.hidden = true;
}
